import { Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading } from "../../Styles/style";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LockerMenu = (props) => {
  const handleClick = () => {
    const textToCopy = '0xf994cab2f787159725372004142a685ea9576824';
    navigator.clipboard.writeText(textToCopy);
    // toast.success('Not deployed yet');
    toast.success('Contract Copied!');
  };

  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Home",
      link: "/#home",
    },
    {
      title: "About",
      link: "#about",
    },
    {
      title: "Tokenomics",
      link: "#tokenomics",
    },
    {
      title: "Contract",
      onClick: handleClick,
    },
  ];
  return (
    <>
    <div
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
      <ToastContainer />
    </div>
    </>
  );
};

export default LockerMenu;
